import React, { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const GalleryCarousel = ({ items, seeMoreLink, seeMoreCover }) => {
  const scrollContainerRef = useRef(null);
  const [isAtEnd, setIsAtEnd] = useState(false);

  // Check scroll position to toggle overlay
  const checkScroll = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainerRef.current;
      // Show overlay when within 50px of the end
      if (scrollWidth - scrollLeft - clientWidth < 50) {
        setIsAtEnd(true);
      } else {
        setIsAtEnd(false);
      }
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener('scroll', checkScroll);
      // Initial check
      checkScroll();
      return () => container.removeEventListener('scroll', checkScroll);
    }
  }, []);

  const scroll = (direction) => {
    if (scrollContainerRef.current) {
      const { current } = scrollContainerRef;
      const scrollAmount = 300; // Adjust scroll amount as needed
      current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="project-carousel-container position-relative">
      {/* Left Arrow */}
      <button
        className="carousel-arrow left-arrow"
        onClick={() => scroll('left')}
        aria-label="Scroll left"
        style={{ zIndex: 20 }}
      >
        &lt;
      </button>

      {/* Scrollable Track */}
      <div className="carousel-track" ref={scrollContainerRef}>
        {items.map((item, index) => (
          <div key={index} className="gallery-carousel-item" style={{ flex: '0 0 auto' }}>
             <img 
                src={item.src} 
                alt={item.alt} 
                style={{ 
                    height: '250px', 
                    width: 'auto', 
                    borderRadius: '0.5rem',
                    objectFit: 'cover',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
             />
          </div>
        ))}
        {/* Spacer to ensure we can scroll to the very end to trigger effect comfortably */}
        <div style={{ flex: '0 0 auto', width: '20px' }}></div>
      </div>

      {/* End Overlay */}
      <div 
        style={{
          position: 'absolute',
          inset: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          backdropFilter: 'blur(3px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: isAtEnd ? 1 : 0,
          pointerEvents: isAtEnd ? 'auto' : 'none',
          transition: 'opacity 0.3s ease',
          zIndex: 10,
          borderRadius: '0.5rem'
        }}
      >
        <div style={{ pointerEvents: 'auto' }}>
           <Link to={seeMoreLink} className="btn-minimal btn-primary-minimal" style={{ transform: isAtEnd ? 'scale(1)' : 'scale(0.9)', transition: 'transform 0.3s ease' }}>
              View Full Gallery →
           </Link>
        </div>
      </div>

      {/* Right Arrow */}
      <button
        className="carousel-arrow right-arrow"
        onClick={() => scroll('right')}
        aria-label="Scroll right"
        style={{ zIndex: 20 }}
      >
        &gt;
      </button>
    </div>
  );
};


export default GalleryCarousel;
